// 300 curated teddy bear names — boys, girls, and diverse ethnic backgrounds
export const TEDDY_NAMES: string[] = [
  // Classic English boys
  "Alfie", "Archie", "Arthur", "Benjamin", "Bobby", "Charlie", "Chester", "Clive",
  "Cornelius", "Dexter", "Douglas", "Edgar", "Edmund", "Edward", "Ernest", "Felix",
  "Finley", "Freddie", "George", "Gilbert", "Harold", "Harry", "Henry", "Herbert",
  "Hugo", "Humphrey", "Jack", "Jacob", "James", "Jasper", "Leo", "Lewis",
  "Liam", "Louis", "Lucas", "Magnus", "Max", "Monty", "Noah", "Noel",
  "Oliver", "Oscar", "Otto", "Paddington", "Patrick", "Percy", "Philip", "Ralph",
  "Reginald", "Reggie", "Rupert", "Samuel", "Sebastian", "Stanley", "Teddy", "Theodore",
  "Thomas", "Timothy", "Tobias", "Walter", "William", "Winston",

  // Classic English girls
  "Ada", "Agatha", "Alice", "Amelia", "Annabel", "Arabella", "Beatrice", "Bella",
  "Bertha", "Blossom", "Bonnie", "Buttercup", "Camilla", "Cecily", "Charlotte", "Clara",
  "Clementine", "Constance", "Cordelia", "Daisy", "Daphne", "Dorothy", "Edith", "Eleanor",
  "Elizabeth", "Elsie", "Emily", "Emma", "Esme", "Ethel", "Evangeline", "Evelyn",
  "Fern", "Flora", "Florence", "Francesca", "Freya", "Georgia", "Grace", "Harriet",
  "Hazel", "Heidi", "Helena", "Henrietta", "Holly", "Honey", "Imogen", "Iris",
  "Isabella", "Ivy", "Jemima", "Jessica", "Josephine", "Lila", "Lillian", "Lily",
  "Lottie", "Louisa", "Lucy", "Mabel", "Maisie", "Margaret", "Margot", "Martha",
  "Matilda", "Mildred", "Millicent", "Millie", "Minerva", "Myrtle", "Nora", "Olive",
  "Ophelia", "Ottilie", "Pearl", "Penelope", "Phoebe", "Pippa", "Poppy", "Primrose",
  "Rosalind", "Rose", "Rosie", "Ruby", "Ruth", "Saffron", "Sophia", "Stella",
  "Tabitha", "Theodora", "Violet", "Vivienne", "Wendy", "Winifred", "Zinnia",

  // Playful / whimsical
  "Barnaby", "Bramble", "Bruno", "Biscuit", "Buttons", "Cinnamon", "Cocoa", "Cookie",
  "Crumble", "Cuddles", "Dotty", "Fudge", "Ginger", "Maple", "Marmalade", "Muffin",
  "Nutmeg", "Patches", "Peanut", "Pickles", "Pudding", "Pumpkin", "Snuggles", "Toffee",
  "Treacle", "Truffle", "Waffle", "Ziggy",

  // South Asian
  "Aarav", "Anaya", "Arjun", "Diya", "Ishaan", "Kavya", "Meera", "Priya",
  "Rohan", "Sita",

  // East Asian
  "Akira", "Hana", "Haruki", "Kaito", "Mei", "Ren", "Sakura", "Yuki",
  "Wei", "Lian",

  // African
  "Amara", "Ayo", "Chidera", "Emeka", "Imani", "Kwame", "Nia", "Oba",
  "Zara", "Zuri",

  // Arabic / Middle Eastern
  "Amina", "Farah", "Fatima", "Hafsa", "Idris", "Layla", "Omar", "Rania",
  "Samir", "Yasmin",

  // Latin / Hispanic
  "Carlos", "Elena", "Esperanza", "Lucia", "Luna", "Mateo", "Paloma", "Rafael",
  "Rosa", "Sofia",

  // Celtic / Irish / Welsh
  "Aisling", "Cian", "Cerys", "Declan", "Eoin", "Niamh", "Rhys", "Saoirse",
  "Sienna", "Taliesin",

  // Additional variety
  "Albert", "Bertie", "Boris", "Cecil", "Clarence", "Clover", "Ebony", "Figaro",
  "Giselle", "Hamish", "Ivy", "Juniper", "Kit", "Lancelot", "Marguerite", "Neville",
  "Orlando", "Petunia", "Quentin", "Raphael", "Sage", "Tansy", "Ursula", "Willow",
];
